/** Code langue → code pays du drapeau SVG (assets/flags/, paquet flag-icons), pour les langues
 *  sans correspondance 1:1 (en→gb ; ar→ma, les patients arabophones de Waitora étant marocains).
 *  Drapeaux SVG plutôt qu'emoji : sur Windows, Segoe UI Emoji n'affiche pas les drapeaux pays
 *  (rendu en texte brut "FR"/"MA" par choix de Microsoft) — une image garantit un rendu
 *  identique sur tous les OS/navigateurs. */
const FLAG_COUNTRY: Record<string, string> = { en: 'gb', ar: 'ma' };

export function flagIcon(lang: string): string {
  const country = FLAG_COUNTRY[lang] ?? lang;
  return `assets/flags/${country}.svg`;
}
